import { createSelector } from 'reselect'
import { RootState } from '../types'

export const addNewWalletPopupSelector = (state: RootState): RootState['userWallets']['addNewWalletPopup']['open'] =>
  state.userWallets.addNewWalletPopup.open

export const addNewWalletPopupCurrencySelector = (
  state: RootState,
): RootState['userWallets']['addNewWalletPopup']['currency'] => state.userWallets.addNewWalletPopup.currency

export const addNewWalletStartTimeSelector = (
  state: RootState,
): RootState['userWallets']['checkClientAddressAndGenerateNewAddress']['created'] =>
  state.userWallets.checkClientAddressAndGenerateNewAddress.created

export const isLoadingCheckClientAddressAndGenerateNewAddressSelector = createSelector(
  (state: RootState) => state.userWallets.checkClientAddressAndGenerateNewAddress.status,
  (status) => status === 'LOADING',
)

export const isSuccessCheckClientAddressAndGenerateNewAddressSelector = createSelector(
  (state: RootState) => state.userWallets.checkClientAddressAndGenerateNewAddress.status,
  (status) => status === 'SUCCESS',
)

export const generatedAddressSelector = (
  state: RootState,
): RootState['userWallets']['checkClientAddressAndGenerateNewAddress']['address'] =>
  state.userWallets.checkClientAddressAndGenerateNewAddress.address

export const confirmReceivedAmountSelector = (
  state: RootState,
): RootState['userWallets']['confirmReceivedAmount']['open'] => state.userWallets.confirmReceivedAmount.open

export const isLoadingConfirmReceivedAmountSelector = createSelector(
  (state: RootState) => state.userWallets.confirmReceivedAmount.status,
  (status) => status === 'LOADING',
)

export const confirmReceivedAmountDataSelector = (
  state: RootState,
): RootState['userWallets']['confirmReceivedAmount'] => state.userWallets.confirmReceivedAmount

export const isLoadingRequestSettlementSelector = createSelector(
  (state: RootState) => state.userWallets.requestSettlement.status,
  (status) => status === 'LOADING',
)
export const requestSettlementPopupSelector = (
  state: RootState,
): RootState['userWallets']['requestSettlement']['open'] => state.userWallets.requestSettlement.open
